<template>
  <div name="1">
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-map-marker</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.site') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px">{{ title }}</h5>
    </v-toolbar>
    <select-image
      v-show="!collapseContent"
      v-model="content.SiteImage"
      :isFullWidth="true"
      :enterpriseID="enterpriseID"
      :imageOld='content.SiteImage'
      @input="handleChangeIsModified"
      style="margin-left:0px;margin-top:15px;margin-right: 0px;"
      width="100px"
    />
    <translate
      v-show="!collapseContent"
      v-model="content.SiteTitle"
      :languages="languages"
      :label="$t('site.title')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <translate
      v-show="!collapseContent"
      v-model="content.SiteSubtitle"
      :languages="languages"
      :label="$t('site.subtitle')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <div style="margin: 0 -10px;background-color:#EAEAEA; padding: 20px 15px 0 15px;">
      <div style="padding: 0 10px 0 10px;">
        <address-find
          :id="content.ID"
          :onUpdateAddress="handleUpdateAddress"
        />
      </div>
      <v-layout align-center wrap style="margin-top: -10px;padding:0 0px 20px 0px;">
        <v-flex xs6 style="padding-right: 5px;">
          <v-text-field
            v-show="!collapseContent"
            v-model="content.SiteLat"
            append-icon="mdi-search"
            :label="$t('site.lat')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex>
        <v-flex xs6 style="padding-left: 5px;">
          <v-text-field
            v-show="!collapseContent"
            v-model="content.SiteLon"
            append-icon="mdi-search"
            :label="$t('site.lon')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-show="!collapseContent"
            v-model="content.SiteAddress"
            append-icon="mdi-search"
            :label="$t('site.address')"
            hideDetails
            @input="handleChangeIsModified"
          />
        </v-flex>
      </v-layout>
    </div>
    <v-text-field
      v-show="!collapseContent"
      v-model="content.SitePhone"
      append-icon="mdi-search"
      :label="$t('site.phone')"
      hideDetails
      @input="handleChangeIsModified"
    />
    <v-text-field
      v-show="!collapseContent"
      v-model="content.SiteWeb"
      append-icon="mdi-search"
      :label="$t('site.web')"
      hideDetails
      @input="handleChangeIsModified"
    />
    <v-text-field
      v-show="!collapseContent"
      v-model="content.SiteEmail"
      append-icon="mdi-search"
      :label="$t('site.email')"
      hideDetails
      @input="handleChangeIsModified"
    />
    <br v-if="!collapseContent"/>
    <translate
      v-show="!collapseContent"
      type="richText"
      v-model="content.SiteMoreInfo"
      :languages="languages"
      :label="$t('site.moreInfo')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <v-layout 
      v-show="!collapseContent"
      align-center wrap 
      style="margin-top: 10px;padding:10px 10px 20px 10px;background-color:#cccccc80;"
    >
      <v-flex xs6>
        <v-checkbox
          v-model="content.SiteLink"
          :label="$t('site.siteLink', locale)"
          @change="handleChangeIsModified"
          hideDetails
        />
      </v-flex>
      <v-flex 
        xs6
        style="padding-left: 5px;"
      >
        <v-checkbox
          v-if="content.SiteLink"
          v-show="!collapseContent"
          v-model="content.SiteLinkDialog"
          :label="$t('site.siteLinkDialog')"
          hideDetails
          @change="handleChangeIsModified"
        />
      </v-flex>
      <v-flex 
        v-if="content.SiteLink"
        xs12
        style="padding: 20px 0 0 0;"
      >
        <v-select 
          v-if="forms"
          v-model="content.SiteForm"
          :items="forms"
          :label="$t('dtouch.formCio.form', locale)"
          item-text="Name"
          item-value="ID"
          outlined
          dense
          hide-details
          @change="handleChangeIsModified"
        />
      </v-flex>
      <v-flex 
        v-if="content.SiteLink"
        xs12
        style="text-align: center; padding-top: 20px;"
      >
        - o -
      </v-flex>
      <v-flex 
        v-if="content.SiteLink"
        xs6
        style="padding-right: 5px;"
      >
        <translate
          v-if="content.SiteLinkURL"
          v-model="content.SiteLinkURL"
          :languages="languages"
          :label="$t('site.siteLinkURL')"
          @input="handleChangeIsModified"
          style="padding: 15px 10px 0 10px;"
        />
      </v-flex>
      <v-flex 
        v-if="content.SiteLink"
        xs6
        style="padding-right: 5px;"
      >
        <translate
          v-if="content.SiteLinkName"
          v-show="!collapseContent"
          v-model="content.SiteLinkName"
          :languages="languages"
          :label="$t('site.siteLinkName')"
          @input="handleChangeIsModified"
          style="padding: 15px 10px 0 10px;"
        />
      </v-flex>
    </v-layout>
  </div>
    </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import api from '@/services/api'
  import SelectImage from '@/components/SelectImage'
  import Translate from '@/components/Translate'
  import AddressFind from '@/components/AddressFind'
  export default {
    components: {
      SelectImage,
      Translate,
      AddressFind
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      forms: null,
    }),
    computed: {
      ...mapState('app',['collapseContent', 'locale']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      languages () {
        return this.$store.state.app.Languages
      },
      title () {
        const aux = this.content && this.content.SiteTitle ? utils.getTranslation (this.content.SiteTitle, this.locale) : ''
        return aux ? aux.toUpperCase() : aux
      },
    },
    mounted() {
      this.handleGetForms()
      this.content.SiteLinkURL = this.content.SiteLinkURL && typeof this.content.SiteLinkURL === 'string' ? JSON.parse(this.content.SiteLinkURL) : this.content.SiteLinkURL
      this.content.SiteLinkName = this.content.SiteLinkName && typeof this.content.SiteLinkName === 'string' ? JSON.parse(this.content.SiteLinkName) : this.content.SiteLinkName
      //if (!this.content.SiteLinkURL) this.content.SiteLinkURL = { es: '' }
      //if (!this.content.SiteLinkName) this.content.SiteLinkName = { es: '' }
    },
    methods: {
      handleGetForms () {
        api.getAll(`enterprises/${this.enterpriseID}/form-cio`, true).then(response => {
          this.forms = response
        })
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      },
      handleUpdateAddress (address) {
        this.handleChangeIsModified()
        this.content.SiteAddress = address.address
        this.content.SiteLon = address.lon
        this.content.SiteLat = address.lat
      }
    }
  }
</script>

<style scoped>
</style>

